module.exports = __webpack_public_path__ + "img/for-women-4.7254936.webp";